import React from 'react'

const UsesBenefits = () => {
  const benefits = [
    {
      icon: "https://cdn.clevdoc.com/uploads//blog/images/WhatsApp+Image+2026-08-11+at+4.06.33+PM.jpeg",
      text: "Automated, multi-channel delivery of notices and reminders to borrowers, sent through SMS, WhatsApp, IVR, and email."
    },
    {
      icon: "https://cdn.clevdoc.com/uploads//blog/images/WhatsApp+Image+2026-08-11+at+4.06.33+PM+(1).jpeg",
      text: "A timestamped, verifiable record of every communication sent, ready for SARFAESI compliance if a case moves to recovery."
    },
    {
      icon: "https://cdn.clevdoc.com/uploads//blog/images/WhatsApp+Image+2026-08-11+at+4.06.33+PM+(2).jpeg",
      text: "Less manual work drafting, sending, and tracking notices across a large loan book."
    },
    {
      icon: "https://cdn.clevdoc.com/uploads//blog/images/WhatsApp+Image+2026-08-11+at+4.06.33+PM+(3).jpeg",
      text: "A clear view of which accounts have been notified, and which are still pending."
    },
  ]

  return (
    <>
      <div className='bg-slate-50 py-16 border-t'>
        <div className='container mx-auto'>
          <div className='bg-white text-slate-800 md:mx-10 mx-5 mb-16 rounded-2xl p-8 md:p-12 shadow-xl border border-slate-100'>

            <div className='mb-16 text-center'>
              <h1 className='md:text-[35px] text-[28px] text-[#0B1E59] font-semibold'>
               Key Benefits
              </h1>
              {/* <p className='text-slate-500 mt-3 text-base md:text-lg'>Find your Benefits</p> */}
            </div>

            <div className='max-w-5xl mx-auto flex flex-col gap-16 md:gap-20'>
              {benefits.map((item, index) => {
                const isEven = index % 2 === 1
                return (
                  <div
                    key={index}
                    className={`flex flex-col ${isEven ? 'md:flex-row-reverse' : 'md:flex-row'} items-center gap-8 md:gap-14`}
                  >
                    {/* image */}
                    <div className='flex-shrink-0 w-full md:w-[320px] flex items-center justify-center'>
                      <div className='w-full max-w-[300px] aspect-square rounded-2xl bg-slate-50 border border-slate-200 shadow-sm flex items-center justify-center p-6'>
                        <img
                          src={item.icon}
                          alt={`benefit-${index + 1}`}
                          className='w-full h-full object-contain'
                        />
                      </div>
                    </div>

                    {/* text */}
                    <div className='flex-1'>
                      <p className={`text-lg md:text-2xl leading-8 text-slate-700 text-center ${isEven ? 'md:text-right' : 'md:text-left'}`}>
                        {item.text}
                      </p>
                    </div>
                  </div>
                )
              })}
            </div>

          </div>
        </div>
      </div>
    </>
  )
}

export default UsesBenefits
